module.exports = __webpack_public_path__ + "static/media/icon_arrow6.417475d3.svg";